import { inject } from "#imports";
import { INJECT_EDIT_LOGGER } from "../symbols.js";
export default function() {
  return inject(INJECT_EDIT_LOGGER);
}
